module.exports = __webpack_public_path__ + "img/202411290101.de044f7a.png";